import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../../components/Sidebar/Sidebar';
import Thumbnail from '../../assets/images/work/ablab/thumbnail.jpg';
import Product from '../../assets/images/work/ablab/ablab_product.png';
import Overview from '../../assets/images/work/ablab/ablab_overview.png';
import BeforeAfter from '../../assets/images/work/ablab/before_after.png';
import './Ablab.css'; 
import '../raiden/raiden.css';
import '../SinglePost.css';

function Ablab() {
    // 見出し情報とアクティブな見出しを管理する状態
        const [headings, setHeadings] = useState([]);
        const [activeHeadingId, setActiveHeadingId] = useState(null);
    
        // コンテンツのDOMを参照するためのref
        const contentRef = useRef(null);
    
        // ① コンテンツを通常のJSXで記述
        const contentJSX = (
            <div>
               <div className="article-title-block">
                  <h1 className="article-title">あなたを宇宙に巻き込む名刺</h1>
                  <div className="article-sub-title"><strong>ABLabのフィロソフィーを表現するデザイン</strong></div>
               </div>
                          
               <div className="article-info">
                    <div className="use-tool">
                        <strong>使用ツール：</strong>PowerPoint
                    </div>
                    <div className="product-period">
                      <strong>制作期間：</strong>1ヶ月
                    </div>
                </div>
              
                <div className="thumbnail-block">
                    <div>
                        <img 
                            src={Thumbnail} 
                            alt="この記事のサムネイル画像。宇宙ビジネスオンラインコミュニティ「ABLab」の名刺が表示されています。" 
                        /> 
                    </div>  
                </div>

                <section className="overview">
                      <h2>概要</h2>
                      <div className="section-content">
                        <p>宇宙ビジネスオンラインコミュニティ「ABLab」様の名刺をリニューアルをさせていただきました。ABLabという組織がどんな組織なのかをデザインに落とし込み、名刺を受け取った人も一緒に活動したくなるよう工夫をしました。</p>
                          
                      </div>  
                </section>

                <section className="product">
                    <h2>完成品</h2>
                      <div className="section-content">
                      
                        <figure>
                          <img 
                            src={Product} 
                            alt="名刺が３枚並んでおり、左から表のデザイン２パターンと裏のデザイン１パターンが表示されている。" 
                          />
                        <figcaption>表面のデザインの２パターンあります。</figcaption>
                        </figure>
                        
                       
                  
                        <figure>
                          <img 
                              src={BeforeAfter} 
                              alt="右側に旧デザインの名刺、左側に新デザインの名刺が比較されている。" 
                            />
                          <figcaption>左側：旧デザイン、右側：新デザイン</figcaption>
                        </figure>

                          
                      </div>  
                </section>


                <section className="task">
                    <h2>クライアントからの要望・課題</h2>
                    <div className="section-content">
                        
                        <div className="list-block">
                          <p><strong>クライアント様（他メンバーの意見も含む）から以下のような要望のもと、制作を行いました。</strong></p>
                            <ul>
                                <li>ラクスルで発注する。</li>
                                <li>誰でも編集ができるように、デザイン原稿はPowerPointで制作する。</li>
                                <li>シンプルに、引き算にデザインで。宇宙っぽさに走らないでほしい。</li>
                                <li>印刷費は多少高くてもOK。</li>
                                <li>英語は最低限、読み仮名としてあった方が良い。（海外の方々とも交流が多いため）</li>
                            </ul>
                        </div>

                        <div className="list-block">
                          <p><strong>旧デザインから以下の課題が挙げられます。</strong></p>
                            <ul>
                                <li>シンプルでクールなデザインにより、固い印象がある。</li>
                                <li>ABLabらしさやどんな組織なのかを表現、または伝える手段がない。</li>
                            </ul>
                        </div>
                    </div>    
                </section>  

                <section className="target">
                    <h2>ターゲット</h2>
                    <div className="section-content">
                      <div className="list-block">
                          <ul>
                              <li>ABLabを知らない人</li>
                              <li>ABLabを知っているが、どんな団体かを知らない人</li>
                              <li>これから仕事を一緒にする人</li>
                          </ul>
                        </div>
                    </div>
                </section>

                <section className="purpose">
                    <h2>目的</h2>
                    <div className="section-content">
                      <p>ABLabがどんな組織なのかが伝わり、加入し一緒に活動がしたいと思ってもらう。</p>
                    </div>
                </section>

                <section className="point">
                  <h2>デザインのポイント</h2>
                  <div className="section-content">
                  <div className="list-block ablab-point">
                      <ul>
                          <li>表面のデザインが２パターンあり、<strong>２つの名刺を横並びにするとABLabのロゴが完成する</strong>仕掛けにしました。<strong>人と人が繋がることで価値を生み出していくというABLabのフィロソフィー</strong>を表現しました。また、名刺を渡す相手に「ABLabの仲間になってロゴを完成させてほしい」というメッセージを伝えることができます。「地球上の全ての業界を、宇宙産業に巻き込む」というABLabのビジョンを手助けするツールとしての役割を持たせました。</li>
                          <li><strong>QRコードを設置</strong>することで、URLを入力する手間を省き、スピーディーにABLabの活動について知ってもらえるようにしました。これは目的である<strong>「ABLabがどんな組織なのか」を即座に伝える手段</strong>として有効です。</li>
                      </ul>
                  </div>

                  </div>
                  
                </section>

                <section class="design-img">
                  <div className="section-content-wide">
                  <img 
                      src={Overview} 
                      alt="ABLabの名刺を全体図が表示されています。" 
                  />
                  </div>
                </section>

                <section className="summary">
                <h2>学んだこと</h2>
                <div className="section-content">
                    <p>この案件を通して、名刺は単なる連絡先ではなく、組織の理念や物語を伝え、受け手に共感と参画意欲を促す重要なコミュニケーションツールであると実感しました。限られたスペースで情報を効果的に表現する難しさと、デザインに込める思いが受け手に影響を与える力を再認識できた経験となりました。
                    </p>
                </div>

                </section>

              <section className="epilogue">
                <h2>後日談</h2>
                <div className="section-content">
                <p>クライアントや受け手から「いいね！」という温かい感想をいただき、安心しました。その後、デザインにカラーバリエーションを取り入れる展開も検討中です。</p>
                </div>
                

              </section>



                            
                            
                
                            
                
                            
            </div>

        );
        
        // ② コンテンツレンダリング後にrefから見出しを抽出する
        useEffect(() => {
            if (contentRef.current) {
              // querySelectorAllでh2, h3, h4タグを取得
              const headingEls = contentRef.current.querySelectorAll('h2, h3, h4');
              const extractedHeadings = [];
              headingEls.forEach((el, index) => {
                // IDがなければ自動で設定する
                if (!el.id) {
                  el.id = `heading-auto-${index + 1}`;
                }
                // タグ名からレベルを数値として取得
                const level = parseInt(el.tagName.substring(1), 10);
                extractedHeadings.push({
                  id: el.id,
                  text: el.innerText,
                  level: level,
                });
              });
              setHeadings(extractedHeadings);
            }
          }, []); // 一度だけ実行
        
          // ③ スクロールイベントでアクティブな見出しを更新（オプション）
          useEffect(() => {
            function handleScroll() {
              let currentActive = null;
              let minDistance = Infinity;
              headings.forEach(h => {
                const el = document.getElementById(h.id);
                if (el) {
                  const rect = el.getBoundingClientRect();
                  const distance = Math.abs(rect.top);
                  if (distance < minDistance) {
                    minDistance = distance;
                    currentActive = h.id;
                  }
                }
              });
              setActiveHeadingId(currentActive);
            }
            window.addEventListener('scroll', handleScroll);
            return () => window.removeEventListener('scroll', handleScroll);
          }, [headings]);
        
          // ④ クリック時に対象の見出しへスクロールする処理
          const handleClickHeading = (headingId) => {
            const el = document.getElementById(headingId);
            if (el) {
              el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          };
        
        
        return (
            <div className="single-post-container">
      
            <div className="single-post-main"> 
              <div className="back-to-home">
                <Link to="/" className="back-link">← Homeへ戻る</Link>
              </div>
    
              <div className="single-post-content" ref={contentRef}>
                {contentJSX}
              </div>
    
              <div className="back-to-home">
                <Link to="/" className="back-link">← Homeへ戻る</Link>
              </div>
            </div>
      
            <Sidebar
              headings={headings}
              activeHeadingId={activeHeadingId}
              onClickHeading={handleClickHeading}
            />
            
          </div>    
                
                
        );    

}
export default Ablab;      